export default __webpack_public_path__ + "static/media/goshen18.acc6a598.jpg";